import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { auth } from '../firebase'

export default class Register extends Component {

    constructor(props) {
        super(props);

        this.state = {

            name: '',
            email: 'rohitxyzenator@gmail.com',
            password: '',
            error: null,
            valid: false,
            working: false
        };
    }
    async   onRegister() {

        if (this.state.working) {
            return;
        }
        const isEmailValid = auth.validateEmail(this.state.email);
        if (!isEmailValid) {

            this.setState({ valid: false, error: "Please enter a valid email address.", working: false })
            return;
        }
        if ((!this.state.password) || this.state.password.length < 5) {

            this.setState({ valid: isEmailValid, error: "Please enter a valid password (atleast 5 characters)", working: false })
            return;
        }
        if ((!this.state.name) || this.state.name.length < 1) {

            this.setState({ valid: isEmailValid, error: "Please enter a name", working: false })
            return;
        }
        this.setState({ valid: false, working: true });
        try {
            await auth.registerUser(this.state.name, this.state.email, this.state.password);
        }
        catch (error) {

            this.setState({
                password: '',
                error: error.message,
                working: false
            });
        }
    };

    handleEmailChange(e) {

        this.setState({
            email: e.target.value
        });
    };
    handleNameChange(e) {

        this.setState({
            name: e.target.value
        });
    };
    handlePasswordChange(e) {

        this.setState({
            password: e.target.value
        });
    };

    render() {

        return (
            <section class="hero is-fullheight is-light">
                <div class="hero-body">
                    <div class="container">
                        <div class="column is-4 is-offset-4">
                            <div class="box">
                                <div class='content'>
                                    <h1 class="title has-text-centered">
                                        Sign Up
                                    </h1>
                                    Please provide the details to create a new account.
                                    </div>
                                <form>
                                    <div class="field">
                                        <div class="control">
                                            <input
                                                class="input is-medium"
                                                type="text"
                                                placeholder="Your Name"
                                                autofocus=""
                                                value={this.state.name}
                                                onChange={this.handleNameChange.bind(this)} />
                                        </div>
                                    </div>
                                    <div class="field">
                                        <div class="control">
                                            <input
                                                class="input is-medium"
                                                type="email"
                                                placeholder="Your Email"
                                                autofocus=""
                                                value={this.state.email}
                                                onChange={this.handleEmailChange.bind(this)} />
                                        </div>
                                    </div>
                                    <div class="field">
                                        <div class="control">
                                            <input
                                                class="input is-medium"
                                                type="password"
                                                placeholder="Your Password"
                                                value={this.state.password}
                                                onChange={this.handlePasswordChange.bind(this)} />
                                        </div>
                                    </div>
                                    {/* <div class="field">
                                        <div class="control">
                                            <label class="checkbox">
                                                <input type="checkbox" />
                                                I agree to the terms and conditions
                                            </label>
                                        </div>
                                    </div> */}
                                    {this.state.error && this.state.error.length > 0 && <div className="notification is-danger">
                                        <i class="fa fa-exclamation-circle" aria-hidden="true" style={{ marginRight: 10 }}></i> {this.state.error}
                                    </div>}
                                    <a class={"button is-block is-info is-medium" + (this.state.working ? " is-loading":"")} style={{ marginTop: 10 }} onClick={this.onRegister.bind(this)}>Register</a>
                                </form>

                                <div style={{ marginTop: 10 }}>
                                    <Link to='/login' class="button is-white is-block">Already registered? Log In</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/register.js